import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Compact APE stat card — same shell as the Incepted APE card (accent rail,
 * header + period pill, KPI typography) but without the donut/legend. Used for
 * the Submission / Pending cards so every APE card is visually uniform.
 */
@Component({
  selector: 'app-ape-stat-card-v2',
  imports: [CommonModule],
  templateUrl: './ape-stat-card-v2.component.html',
  styleUrl: './ape-stat-card-v2.component.scss'
})
export class ApeStatCardComponentV2 {
  @Input() title = 'APE';
  @Input() period = '';
  @Input() value = 0;
  @Input() cases = 0;
  /** Eyebrow above the value (e.g. "Singlife"). */
  @Input() valueLabel = 'APE';
  /** Top accent-rail colour. */
  @Input() accent = '#3d8bf0';
}
